import React, { useRef, useState } from "react";
import ct from "class-types.macro";
import { CategoryDetail } from "~/common/Store/models/Category";
import RelatedCategoryCarousel from "~/CategoryPage/RelatedCategoryCarousel";
import RelatedResourcesLeaf from "./RelatedResourcesLeaf";
import InternalNotesButton from "./InternalNotes/InternalNotesButton";
import InternalNotesModal from "./InternalNotes/InternalNotesModal";
import useOnClickOutside from "~/common/hooks/useOnClickOutside";
import InternalNotesButtonV2 from "./InternalNotes/InternalNotesButtonV2";
import { useFeatureFlag } from "~/common/contexts/FeatureFlagProvider";
const LeafFooter = (detail: CategoryDetail) => {
  const {
    bottomDescription
  } = detail;
  const hasVisibleText = detail.visibleText && detail.visibleText.length > 0;
  const hasHiddenText = detail.hiddenText && detail.hiddenText.length > 0;
  const vendorLinks = detail.vendorLinks || [];
  const {
    evaluateFlag
  } = useFeatureFlag();
  const categoryInternalNotesIsEnabled = evaluateFlag("category-internal-notes-v2");
  const [showInternalNotesModal, setShowInternalNotesModal] = useState(false);
  const internalNotesRef = useRef(null);
  useOnClickOutside(internalNotesRef, () => setShowInternalNotesModal(false));
  let brandsCount = 0;
  if (vendorLinks.length > 7) {
    brandsCount = 7;
  } else {
    brandsCount = vendorLinks.length;
  }
  let listDesc;
  if (detail.linkedResources.length > 0) {
    listDesc = "xxl:w-4/5 xl:w-3/4";
  }
  return <>
      {detail.relatedCategories && <RelatedCategoryCarousel categoryName={detail.name} parentCategoryName={detail.parent?.name} relatedCategories={detail.relatedCategories} />}
      <div className="xl:flex gap-4 clear-both">
        <div className={listDesc}>
          <div className="padded-subtle small">
            {detail.categoryBannerInfo && !detail.categoryBannerInfo.halfSize && <div className="category-banner">
                  <a href={detail.categoryBannerInfo.url} title={detail.categoryBannerInfo.altText}>
                    <img src={`/images/site/ads/category/${detail.categoryBannerInfo.image}`} alt={detail.categoryBannerInfo.altText} />
                  </a>
                </div>}
            {hasVisibleText && <p // added style classes to target the anchor tags located within the dangerouslySetInnerHTML text
          className={ct("[&>a]:underline", "[&>a]:text-lime-800")} dangerouslySetInnerHTML={{
            __html: detail.visibleText
          }} />}
            {hasHiddenText && <p
          // added style classes to target the anchor tags located within the dangerouslySetInnerHTML text
          className={ct("[&>a]:underline", "[&>a]:text-lime-800")} dangerouslySetInnerHTML={{
            __html: detail.hiddenText
          }} />}
            {bottomDescription && <div
          // added style classes to target the anchor tags located within the dangerouslySetInnerHTML text
          className={ct("[&>a]:underline", "[&>a]:text-lime-800")} dangerouslySetInnerHTML={{
            __html: bottomDescription
          }} />}
            {vendorLinks.length > 0 && <p>
                <span>
                  {"Also make sure to check out other great items from "}
                </span>
                <>
                  {vendorLinks.slice(0, 7).map((x, index) => <>
                      <a className={ct("underline", "text-lime-800")} href={x.link} title={x.title} key={x.title}>
                        {x.title}
                      </a>
                      {`${index < brandsCount - 2 ? ", " : index < brandsCount - 1 ? " and " : "."}`}
                    </>)}
                </>
              </p>}
          </div>
        </div>
        {detail.linkedResources.length > 0 && <div className="xxl:w-1/5 xl:w-1/4 block">
            <RelatedResourcesLeaf {...{
          linkedResources: detail.linkedResources
        }} />
          </div>}
      </div>
      {showInternalNotesModal && <InternalNotesModal toggleInternalNotesModal={() => setShowInternalNotesModal(!showInternalNotesModal)} internalNotesRef={internalNotesRef}></InternalNotesModal>}
      {categoryInternalNotesIsEnabled ? <InternalNotesButtonV2 categoryId={detail.id} showInternalNotesModal={showInternalNotesModal} toggleInternalNotesModal={() => setShowInternalNotesModal(!showInternalNotesModal)} /> : <InternalNotesButton categoryId={detail.id} />}
    </>;
};
export default LeafFooter;